import {
  GET_CONTACT_STRATEGY_REQUEST,
  GET_CONTACT_STRATEGY_SUCCESS,
  GET_CONTACT_STRATEGY_FAILURE,
  UPDATE_CONTACT_STRATEGY_REQUEST,
  UPDATE_CONTACT_STRATEGY_SUCCESS,
  UPDATE_CONTACT_STRATEGY_FAILURE,
  statusType
} from '../../actions'

const initial = {
  data: [],
  status: statusType.IDLE
}

const strategy = (state = initial, action) => {
  switch (action.type) {
    case GET_CONTACT_STRATEGY_REQUEST:
      return {
        ...state,
        status: statusType.IN_PROGRESS
      }

    case GET_CONTACT_STRATEGY_SUCCESS:
      return {
        ...state,
        data: action.payload || [],
        status: statusType.SUCCESS
      }

    case GET_CONTACT_STRATEGY_FAILURE:
      return {
        ...initial
      }

    case UPDATE_CONTACT_STRATEGY_REQUEST:
      return {
        ...state,
        status: statusType.IN_PROGRESS
      }

    case UPDATE_CONTACT_STRATEGY_SUCCESS:
      return {
        ...state,
        data: action.payload || [],
        status: statusType.SUCCESS
      }

    case UPDATE_CONTACT_STRATEGY_FAILURE:
      return {
        ...initial
      }

    default:
      return state
  }
}

export default strategy
